<template>
    <div>
<!--        发起失败-->
        <avue-crud :data="data" :option="option" :page.sync="page" @current-change="changePage" @search-change="searchChange" @search-reset="resetChange">
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item  class="pull-down" @click.native="failureBtn(scope.row)">删除</el-dropdown-item>
                <el-dropdown-item  class="pull-down" @click.native="viewBtn(scope.row)">查看</el-dropdown-item>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="system_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.system_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.system_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="faqi_ren" slot-scope="scope" >
                <el-tooltip :content="scope.row.faqi_ren" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.faqi_ren }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
        <el-dialog
                title="提示"
                :visible.sync="deleteData"
                :close-on-click-modal="false"
                width="30%">
            <span>删除合同后，会归还发起失败的合同份数</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteData = false">取 消</el-button>
                <el-button type="primary" @click="determineBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { allContracts, allContractsSearch, failureFile } from '../../../api/allContracts';

    export default {
        name: 'initiationFailure',
        inject: ['reload'],
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                deleteData:false,
                id:'',
                data: [],
                doc_title:'',
                all_signers:'',
                option:{
                    menuType: 'menu',
                    menuBtnTitle:'操作',
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:150,  //操作栏宽度设置
                    column:[
                        {
                            label:'合同名称',
                            prop:'doc_title',
                            // search:true
                        }, {
                            label:'平台编号',
                            prop:'system_sn'
                        },  {
                            label:'合同编号',
                            prop:'contract_sn'
                        },  {
                            label:'发起人',
                            prop:'faqi_ren'
                        },  {
                            label:'发起时间',
                            prop:'faqi_time'
                        },  {
                            label:'参与人',
                            prop:'all_signers',
                            // search: true
                        },  {
                            label:'合同状态',
                            prop:'ct_status_txt'
                        },  {
                            label:'合同完成时间',
                            prop:'finish_time'
                        }
                    ]
                },
            };
        },
        methods:{
            //分页
            changePage(num){
                if (this.doc_title==''&&this.all_signers=='') {
                    allContracts(9, 10, num).then(res => {
                        this.data = res.data.list
                        this.page.total = res.data.count
                    })
                }else {
                    //搜索后分页
                    allContractsSearch(9,10,num,this.doc_title,this.all_signers).then(res=>{
                        if (res.code==200){
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    })
                }
            },
            //搜索
            searchChange(from,done){
                allContractsSearch(9,10,1,from.doc_title,from.all_signers).then(res=>{
                    this.doc_title=from.doc_title
                    this.all_signers=from.all_signers
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                })
                done()
            },
            //重置搜索
            resetChange(){
                this.doc_title=''
                this.all_signers=''
                allContracts(9,10,1).then(res=>{
                    this.data=res.data.list
                    this.page.total=res.data.count
                    this.page.currentPage=1
                })
            },
            //发起失败
            failureBtn(row){
                this.id=row.id
                this.deleteData=true

            },
            //确认删除
            determineBtn(){
                failureFile(this.id).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.reload()
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //发起失败详情
            viewBtn(row){
                this.$router.push({path:'/loseDetail',query:{id:row.id}})
            }
        },
        created() {
            this.resetChange()
        }
    };
</script>

<style scoped>
    /deep/.el-col{
        width: 25%;
    }
    /deep/.avue-form__menu{
        padding: 0px;
    }
    /deep/ .el-tabs__active-bar{
        background-color: #3d62f6;
    }
    .View{
        background-color: #3e62f6;
        color: #fff;
    }
    /deep/.el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    /deep/.el-icon-arrow-down {
        font-size: 15px;
    }
    .pull-down{
        padding: 5px 30px !important;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
    ::v-deep .avue-crud__menu{
        min-height:0px !important;
        height: 0px !important;
    }
</style>
